const dsgpoResources = {
  en: {
    dsgpo: {
      title: 'Voluntary civil liability car insurance',
      calculator: 'Insurance calculator',
      'Подробнее о ДГПО авто': 'Подробнее о ДГПО авто',
      'description.title': 'Description',
      'description.text1':
        'Попав в дорожное происшествие, которое случилось по вашей вине, страховая компания возместит убыток пострадавшему по обязательной автостраховке. Но лимита по ней может не хватить.',
      'description.text1.1':
        'Тогда оставшуюся часть нанесенного ущерба за вас покроет добровольная дополнительная автостраховка в пределах той страховой суммы, которую вы выбрали. Полис ДГПО авто работает только в связке с ОГПО ВТС.',
      'description.text2': 'Policyholders – ',
      'description.text3': 'individuals and legal entities',
      'description.text4': 'Insured persons – ',
      'description.text5': 'persons admitted to driving a vehicle',
      'description.text6': 'Insured event – ',
      'description.text7':
        'causing harm to the life, health or property of third parties as a result of a traffic accident',
      'description.text8': 'Types of vehicles accepted for insurance – ',
      'description.text9':
        'cars, trucks, buses, trailers, construction machinery, specialized machinery, agricultural machinery',
      'description.text10': 'Insurance territory: ',
      'description.text11': 'Republic of Kazakhstan',
      'description.text12': 'Insurance amount: ',
      'description.text13':
        'from 500,000 (five hundred thousand) to 5,000,000 (five million) tenge',
      'description.text14': 'Tariff:',
      'description.text15':
        'For vehicles not registered with the traffic police - ',
      'description.text16': 'from 0.60%',
      'description.text17':
        'For vehicles subject to registration with the traffic police – ',
      'description.text18': 'from 0.23%',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_ru6.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_ru6.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_ru6_B.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_ru6_B.png',
      },
    },
  },
  kz: {
    dsgpo: {
      title: 'АҚЖЕС автосақтандыру',
      calculator: 'Сақтандыру калькуляторы',
      'Подробнее о ДГПО авто': 'АҚЖЕС автосақтандыру туралы толығырақ',
      'description.title': 'Сипаттамасы',
      'description.text1':
        'Жол-көлік оқиғасына өзіңіздің кінәңізбен тап болған жағдайда, міндетті автосақтандыру полисі аясында сақтандыру компаниясы зардап шеккен тарапқа келтірілген шығынды өтейді. Алайда, бұл полис бойынша төлем лимиті барлық шығынды жабуға жетпеуі мүмкін.',
      'description.text1.1':
        'Мұндай жағдайда сіз таңдаған сақтандыру сомасының шегінде қалдық шығынды ерікті түрде рәсімделген қосымша автосақтандыру – АҚЖЕС өтейді. АҚЖЕС автосақтандыру полисі тек КҚИАҚЖАМС полисімен бірге әрекет етеді.',
      'description.text2': 'Сақтанушылар - ',
      'description.text3': 'жеке және заңды тұлғалар',
      'description.text4': 'Сақтандырылушылар - ',
      'description.text5': 'көлік құралын басқаруға рұқсаты бар тұлғалар',
      'description.text6': 'Сақтандыру жағдайы - ',
      'description.text7':
        'жол апаты нәтижесінде үшінші тұлғалардың өміріне, денсаулығына немесе мүлкіне зиян келтірілуі',
      'description.text8':
        'Сақтандыруға қабылданатын көлік құралдарының түрлері – ',
      'description.text9':
        'жеңіл, жүк, автобустар, тіркемелер, құрылыс техникасы, мамандандырылған техника, ауыл шаруашылығы техникасы',
      'description.text10': 'Сақтандыру аумағы: ',
      'description.text11': 'Қазақстан Республикасы',
      'description.text12': 'Сақтандыру сомасы: ',
      'description.text13':
        '500 000 (бес жүз мың) теңгеден 5 000 000 (бес миллион) теңгеге дейін',
      'description.text14': 'Тариф:',
      'description.text15':
        'Жол полициясы органдарында тіркелмеген көлік құралдары үшін - ',
      'description.text16': '0,60% - тен',
      'description.text17':
        'Жол полициясы органдарында тіркелуге жататын көлік құралдары үшін - ',
      'description.text18': '0,23% - тен',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_kz6.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_kz6.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_kz6_B.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_kz6_B.png',
      },
    },
  },
  ru: {
    dsgpo: {
      title: 'ДСГПО автострахование',
      calculator: 'Калькулятор страхования',
      'Подробнее о ДГПО авто': 'Подробнее о ДГПО авто',
      'description.title': 'Описание',
      'description.text1':
        'Попав в дорожное происшествие, которое случилось по вашей вине, страховая компания возместит убыток пострадавшему по обязательной автостраховке. Но лимита по ней может не хватить.',
      'description.text1.1':
        'Тогда оставшуюся часть нанесенного ущерба за вас покроет добровольная дополнительная автостраховка в пределах той страховой суммы, которую вы выбрали. Полис ДГПО авто работает только в связке с ОГПО ВТС.',
      'description.text2': 'Страхователи - ',
      'description.text3': 'физические и юридические лица',
      'description.text4': 'Застрахованные - ',
      'description.text5':
        'лица, допущенные к управлению транспортного средства',
      'description.text6': 'Страховой случай - ',
      'description.text7':
        'причинение вреда жизни, здоровью или имуществу третьих лиц в результате дорожно-транспортного происшествия ',
      'description.text8':
        'Принимаемые на страхование типы транспортных средств – ',
      'description.text9':
        'легковые, грузовые, автобусы, прицепы, строительная техника, специализированная техника, сельскохозяйственная техника',
      'description.text10': 'Территория страхования: ',
      'description.text11': 'Республика Казахстан',
      'description.text12': 'Страховая сумма: ',
      'description.text13':
        'от 500 000 (пятьсот тысяч) до 5 000 000 (пять миллионов) тенге',
      'description.text14': 'Тариф:',
      'description.text15':
        'Для транспортных средств, незарегистрированных в органах дорожной полиции – ',
      'description.text16': 'от 0,60%',
      'description.text17':
        'Для транспортных средств, подлежащих регистрации в органах дорожной полиции – ',
      'description.text18': 'от 0,23%',
      banner: {
        img: 'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_ru6.png',
        imgSm:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_ru6.png',
        imgDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_2016%D1%85158_ru6_B.png',
        imgSmDark:
          'https://api.jgarant.kz/admin/media/Site/Banners/dgpo_343x100_ru6_B.png',
      },
    },
  },
};

export default dsgpoResources;
